import yup from './yup'
import { creationType } from 'constants/index'
import { string } from 'yup'

export const speakerFormSchema = (type) =>
  yup.object().shape({
    firstName: yup.string().label('First Name').trimmedRequired('First name is required'),
    lastName: yup.string().label('Last Name').trimmedRequired('Last name is required'),
    email: yup.string().email().label('Email').required('Email is required'),
    credential: string().label('Credential'),
    position: yup.string().label('Position'),
    company: yup.string().label('Organization'),
    country: string().label('Country'),
    state: string().label('State'),
    city: string().label('City'),
    phone: string().label('Phone'),
    websiteUrl: yup
      .string()
      .trim()
      .test('has-https', 'URL must include the protocol, e.g., https://example.com', (value) => {
        if (!value) return true // handle 'required' separately
        return /^https:\/\//i.test(value)
      })
      .url('Website URL must be a valid URL'),
    bio: yup.string().label('Bio'),
    roles:
      type === creationType.manual
        ? yup.array().of(yup.string()).min(1, 'At least one role is required').label('Roles')
        : yup.array().optional()
  })

export const inviteSpeakerFormSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  roles: yup.array().of(yup.string()).min(1, 'At least one role is required').label('Roles')
})
